import { render, staticRenderFns } from "./OnboardingStepPuedesEmpezar.vue?vue&type=template&id=2805f764"
import script from "./OnboardingStepPuedesEmpezar.vue?vue&type=script&lang=js"
export * from "./OnboardingStepPuedesEmpezar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports